<button
  mat-fab
  color="primary"
  [matMenuTriggerFor]="mainMenu"
  [matTooltip]="'Debug menu'"
  matTooltipClass="custom-tooltip"
>
  <mat-icon>build</mat-icon>
</button>

<mat-menu #mainMenu="matMenu">
  <button mat-menu-item [matMenuTriggerFor]="languageMenu">Language</button>
  <button mat-menu-item [matMenuTriggerFor]="countriesMenu">Country</button>
  <a
    mat-menu-item
    [routerLink]="[
      countryRepo.countryParam$ | async,
      RoutePaths.LanguageSelection,
    ]"
  >
    Language selection page
  </a>
  <a mat-menu-item [routerLink]="['/', RoutePaths.CountrySelection]">
    Country selection page
  </a>
</mat-menu>

<mat-menu #languageMenu="matMenu">
  @for (language of availableLanguages; track $index) {
    <button
      mat-menu-item
      (click)="$event.stopPropagation(); setLanguage(language.id)"
    >
      <img [src]="'assets/images/flags/' + language.flag + '.png'" />
      {{ language.title }}
      @if ((languageRepo.activeLanguageCode$ | async) === language.id) {
        <mat-icon> check </mat-icon>
      }
    </button>
  }
</mat-menu>

<mat-menu #countriesMenu="matMenu">
  @for (country of availableCountries$ | async; track $index) {
    <button
      mat-menu-item
      (click)="$event.stopPropagation(); changeCountry(country)"
    >
      {{ country.name }}
      @if ((countryRepo.activeCountryId$ | async) === country.id) {
        <mat-icon> check </mat-icon>
      }
    </button>
  }
</mat-menu>
